var yiqi =[
      // ----智慧伊旗-------
      {
        path: '/yqerlogin',
        name: 'login4',
        component: () => import('../views/login4.vue')
    },
    {
        path: '/yiqi',
        name: 'yiqi',
        component: () => import('../views/yqScreen/index.vue')
    },
    {
        path: '/archive',
        name: 'archive',
        component: () => import('../views/yqScreen/archive/index.vue')
    },
    {
        path: '/farchive',
        name: 'farchive',
        component: () => import('../views/yqScreen/archive/farchive.vue')
    },
    {
        path: '/fold',
        name: 'fold',
        component: () => import('../views/yqScreen/fold/index.vue')
    },
    {
        path: '/business',
        name: 'business',
        component: () => import('../views/yqScreen/business.vue')
    },
    {
        path: '/warning',
        name: 'warning',
        component: () => import('../views/yqScreen/warning/index.vue')
    }, {
        path: '/analysis',
        name: 'analysis',
        meta: {
            activeNav: 'analysis',
        },
        component: () => import('../views/yqScreen/analysis/index.vue')
    },
    {
        path: '/yq_index',
        name: 'yq_index',
        meta: {
            activeNav: 'yq_index',
        },
        component: () => import('../views/yqScreen/index/index.vue')
    },
    {
        path: '/animals',
        name: 'animals',
        meta: {
            activeNav: 'animals',
        },
        component: () => import('../views/yqScreen/index/animals/index.vue')
    }, {
        path: '/yq_prediction',
        name: 'yq_prediction',
        meta: {
            activeNav: 'yq_prediction',
        },
        component: () => import('../views/yqScreen/prediction/index.vue')
    },
    /**
     * 伊旗——农业预警
     */
    {
        path: '/agriculture',
        name: 'agriculture',
        meta: {
            activeNav: 'agriculture',
        },
        component: () => import('../views/yqScreen/index/agriculture/index.vue')
    },
    // 畜牧业预警
    {
        path: '/husbandry',
        name: 'husbandry',
        meta: {
            activeNav: 'husbandry',
        },
        component: () => import('../views/yqScreen/index/husbandry/index.vue')
    },
    {
        path: '/yiqiWaring',
        name: 'yiqiWaring',
        meta: {
            activeNav: 'yiqiWaring',
        },
        component: () => import('../views/yqScreen/index/yiqiWaring.vue')
    },

    // ----智慧伊旗-------
]
export default yiqi